import React from "react";
import Contact from "@/components/site/Contact";

export default function ContactPage() {
  return (
    <main data-testid="contact-page" className="pt-20">
      <Contact />
    </main>
  );
}
